import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { SolicitudesService } from '../../../services/user/solicitud/solicitudes.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { CatalogosService } from '../../../services/catalogos.service';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.css'],
  providers: [ConfirmationService, MessageService],
})
export class SolicitudesComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
  solicitudes: any[];
  public id: string;
  public data: string;
  visibleSpinner = false;
  first = 0;
  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  // Modal
  displayModal: boolean;
  nota: string;
  idInstancia: string;
  numero: string;
  tipo: number;
  headermodal: string;
  file1: File;
  tipoDocProrroga = 'solicitud.justificacion.prorroga';

  showMe = false;
  showPr = false;
  title: string;
  view: any;
  scroll: any;

  prorroga: any = {};
  // Filtros de búsqueda
  searching: boolean;
  numeroSolicitud: string;
  nombreEstado: string;
  nombreProceso: string;
  codigoEstado: string[];
  codigoEstadoNOT: string[];
  estado: string;
  iconsearch: string;
  filters: any;
  totalRecords: number;
  contenidoSolicitud: string;
  archivoObligatorio: boolean;
  @ViewChild('fileUpload') fileUpload: FileUpload | undefined;

  aceptar = true;

  constructor(
    public solicitudesService: SolicitudesService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private catalogosService: CatalogosService
  ) {}

  ngOnInit(): void {
    this.scrollHeight(screen.width);
    this.route.params.subscribe((params) => {
      this.visibleSpinner = true;

      this.estado = this.route.snapshot.paramMap.get('estado');
      if (this.estado === 'observadas') {
        this.codigoEstado = ['OBSERVACION.FORMA', 'OBSERVACION.FONDO'];
        this.filters = {
          codigo_estado: this.codigoEstado,
        };
      } else if (this.estado === 'finalizadas') {
        this.codigoEstado = [
          'FIN.TRAMITE.TRAMITE',
          'FIN.TRAMITE.DESISTIDO',
          'FIN.TRAMITE.ARCHIVADO',
          'FIN.TRAMITE.LISTO',
        ];
        this.filters = {
          codigo_estado: this.codigoEstado,
        };
      } else if (this.estado === 'activas') {
        this.codigoEstadoNOT = [
          'FIN.TRAMITE.TRAMITE',
          'FIN.TRAMITE.DESISTIDO',
          'FIN.TRAMITE.ARCHIVADO',
          'FIN.TRAMITE.LISTO',
          'TRAMITE.ABREVIADO',
        ];
        this.filters = {
          codigo_estado_NOT: this.codigoEstadoNOT,
        };
      }

      if (!this.filters) {
        this.filters = { page: 1, rows: 20 };
      } else {
        this.filters.page = 1;
      }
      this.filters.rows = 20;

    });

    this.sw = 'Start';
    this.iconsearch = 'pi pi-search';
  }

  scrollHeight(screen): any {
    let set: any;
    if (screen > 1600) {
      set = screen * 0.65;
    } else {
      set = screen * 0.7;
    }
    this.scroll = screen - set;
  }

  getSolicitudesEvent(event: LazyLoadEvent) {
    const page = (event.first === 0) ? 1 : (Math.round(event.first / event.rows) + 1) ?? 1;

    if (!this.filters) {
      this.filters = {
        page,
        rows: event.rows,
      };
    } else {
      this.filters.page = page;
      this.filters.rows = event.rows;
    }
    this.getSolicitudes(this.filters);
  }

  getSolicitudes(filters): void {
    /**
     * Esta función es la que se encargar de hacer la petición
     * al service para consumir los datos que se mostraran en la tabla,
     * dicho service se debe importar y definir en el constructor.
     */

    this.solicitudes?.length > 0 ? this.solicitudes = [] : null;
    this.visibleSpinner = true;
    this.searching = true;

    this.solicitudesService.getSolicitudes(filters).subscribe(
      (res: any) => {
        if (res.data && res.data.length > 0) {
          this.totalRecords = res.total ? res.total : 0;
          res.data = this.solicitudesService.getDetalles(res.data, null);
          this.solicitudes = res.data;

          if (this.estado === 'observadas') {
            this.solicitudes.forEach(solicitud => {
              solicitud.fecha_maxima = solicitud.fechaSubsanacion;

              if (
                solicitud.estado.codigo_estado_proceso === 'OBSERVACION.FORMA' &&
                (!solicitud.plazo || solicitud.plazo === null)
              ) {
                let fechaObservacion = solicitud.fechas?.fecha_observacion_forma ?? 
                  solicitud.historial
                  ?.filter((h) => h.codigo_estado_proceso === 'OBSERVACION.FORMA')
                  ?.pop()?.created_at;

                if (fechaObservacion) {
                  this.catalogosService.getFechaHabil(fechaObservacion, 10)
                    .subscribe((response: any) => {
                      if (response && response.data) {
                        let fechaMaximaFormatted = response.data;
                        let diasRestantes = response.semaforo;
                        solicitud.fecha_maxima = `${fechaMaximaFormatted} (${diasRestantes} días)`;
                      }
                    });
                }
              }

              let semaforoDias = solicitud.semaforo_dias;
              if (semaforoDias == 0) {
                solicitud.semaforo = 'red';
              } else if (semaforoDias <= 1) {
                solicitud.semaforo = 'black';
              } else if (semaforoDias <= 4) {
                solicitud.semaforo = 'orange';
              } else {
                solicitud.semaforo = 'green';
              }

              solicitud.semaforo_text = semaforoDias !== null && semaforoDias !== undefined ? `${semaforoDias} días` : '';
              this.visibleSpinner = false;
            });
          }
          this.visibleSpinner = false;
          this.searching = false;
          this.iconsearch = 'pi pi-search';
        } else if (res.data.code === 42 || res.data.code > 43) {
          this.visibleSpinner = false;
          this.searching = false;
          this.code = 'refresh.warn.default';
          setTimeout(() => {
            this.router.navigate(['auth/login']);
          }, 2000);
        }
      },
      (error) => {
        this.visibleSpinner = false;
        this.searching = false;
        this.iconsearch = 'pi pi-search';
      }
    );
  }

  showModal(id, numero, tipo): void {

    //DOCUMENTO DE PRORROGA OBLIGATORIO EN TRÁMITES DE PF
    if(numero.includes('PF')){
      this.archivoObligatorio = true;
    }else{
      this.archivoObligatorio = false;
    }

    this.idInstancia = id;
    this.numero = numero;
    this.displayModal = true;
    this.tipo = tipo; // 1. Desistir 2.Prorroga
    if (this.tipo === 1) {
      this.headermodal = 'Desistir de solicitud';
    } else if (this.tipo === 3) {
      this.headermodal = 'Advertencia de eliminación de solicitud';
    } else {
      this.headermodal = 'Solicitar prórroga para subsanar';
    }
  }

  guardarDesistimiento(): void {
    const idEstado = '000zth8s00hdpxn9wgh4ksz49w';

    if (this.nota === undefined || this.nota === '') {
      this.code = 'form.warn.18';
    } else {
      this.visibleSpinner = true;
      this.solicitudesService
        .guardarDesistimientoInstancia(this.idInstancia, idEstado, this.nota)
        .subscribe((res: any) => {
          if (res.success) {
            this.getSolicitudes({});
            this.visibleSpinner = false;
            this.displayModal = false;
            this.code = 'form.success.12';
          } else if (res.data.code === 42 || res.data.code > 43) {
            this.visibleSpinner = false;
            this.code = 'refresh.warn.default';
            setTimeout(() => {
              this.router.navigate(['auth/login']);
            }, 2000);
          } else {
            this.visibleSpinner = false;
            this.displayModal = false;
            this.code = 'form.warn.17';
          }
        });
    }
  }

  EliminarSolicitud(): void {
    this.visibleSpinner = true;
    this.solicitudesService
      .EliminarSolicitud(this.idInstancia)
      .subscribe((res: any) => {
        if (res.success) {
          this.getSolicitudes({});
          this.visibleSpinner = false;
          this.displayModal = false;
          this.code = 'form.success.12';
        } else if (res.data.code === 42 || res.data.code > 43) {
          this.visibleSpinner = false;
          this.code = 'refresh.warn.default';
          setTimeout(() => {
            this.router.navigate(['auth/login']);
          }, 2000);
        } else {
          this.visibleSpinner = false;
          this.displayModal = false;
          this.code = 'form.warn.17';
        }
      });
  }

  CancelarDesistimiento(): void {
    this.displayModal = false;

    if(this.fileUpload){
      this.limpiarArchivo(this.fileUpload);
    }
  }

  getURL(proceso, id): void {
    proceso = proceso.toLowerCase();
    this.router.navigate(['consulta/' + proceso + '/' + id]).then(() => {
      window.location.reload();
    });
  }

  filter(): void {
    // filters
    this.iconsearch = 'pi pi-spin pi-spinner';
    const filters =
      this.estado === 'activas'
        ? {
            numero_solicitud: this.numeroSolicitud,
            nombre_estado: this.nombreEstado,
            nombre_proceso: this.nombreProceso,
            codigo_estado_NOT: this.codigoEstadoNOT,
            contenido_solicitud: this.contenidoSolicitud,
          }
        : {
            numero_solicitud: this.numeroSolicitud,
            nombre_estado: this.nombreEstado,
            nombre_proceso: this.nombreProceso,
            codigo_estado: this.codigoEstado,
            contenido_solicitud: this.contenidoSolicitud,
          };
    this.filters = filters;
    this.getSolicitudes(filters);
  }

  goToPage(pageName: string): void {
    this.router.navigate([`${pageName}`]);
  }

  sendProrroga(uuid_doc): void {
    this.solicitudesService
      .guardarProrrogaInstancia(
        this.idInstancia,
        uuid_doc,
        this.tipoDocProrroga
      )
      .subscribe((res: any) => {
        if (res.success) {
          this.getSolicitudes({});
          this.visibleSpinner = false;
          this.displayModal = false;
          this.code = 'form.success.14';
          
          if(this.fileUpload){
            this.limpiarArchivo(this.fileUpload);
          }
        } else {
          this.visibleSpinner = false;
          this.displayModal = false;
          this.code = 'form.warn.12';
        }
      });
  }

  storeprorroga(): void {
    this.code = null;
    this.confirmationService.confirm({
      message:
        '¿Está seguro que desea solicitar prórroga para la solicitud <b>' +
        this.numero +
        '</b>?',
      header: 'Solicitud de prórroga',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.visibleSpinner = true;

        //MENSAJE CUANDO EL ARCHIVO ES OBLIGATORIO
        if (this.archivoObligatorio && !this.file1) {
          this.visibleSpinner = false;
          this.code = 'form.warn.19';
          return;
        }

        if (this.file1) {
          this.solicitudesService
            .crearSubirDocumento(this.tipoDocProrroga, this.file1)
            .subscribe((response) => {
              const uuid_doc = response;
              this.sendProrroga(uuid_doc);
            });
        } else {
          this.sendProrroga('');
        }
      },
    });
  }
  archivo(file): void {
    this.file1 = file.files[0];
  }

  historialModal(id, numero): void {
    this.title = 'Historial de estados de la solicitud ' + numero;
    this.view = {
      'font-weight': 'normal',
      'text-align': 'left',
      'max-width': '90%',
    };
    this.id = id;
    this.showMe = true;
  }

  prorrogaModal(solicitud): void {
    this.visibleSpinner = true;
    this.title = 'Solicitud de prórroga';
    this.view = {
      'font-weight': 'normal',
      'text-align': 'left',
      'max-width': '90%',
      'line-height': 1.8,
    };
    var plazodias=0;
    var today = new Date(solicitud.fechas.fecha_revision_prorroga);
    var date =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();

    plazodias = 10+solicitud.plazo;
    this.catalogosService
      .getFechaHabil(date,plazodias)
      .subscribe((r) => {
        this.prorroga = {
          numero_solicitud: solicitud.numero_solicitud,
          estado: this.getNombreEstadoProrroga(solicitud),
          fecha_revision: solicitud.fechas.fecha_revision_prorroga,
          comentarios:
            solicitud.prorroga == 3 ? solicitud.comentarios_prorroga : '',
          plazo: solicitud.plazo,
          fecha_prorroga: solicitud.fecha_maxima
        };
        this.showPr = true;
        this.visibleSpinner = false;
      });
  }

  aceptarCondiciones(): void {
    this.aceptar = !this.aceptar;
  }

  spinner(display: boolean): void {
    /**
     * Función que obtiene el valor de display emitido en el modal de historial de la solicitud.
     */
    setTimeout(() => {
      this.visibleSpinner = display;
    }, 10);
  }

  /**
   * Función que obtiene los nombres de los estados de la prorroga de la solicitud.
   * @param solicitud Solicitud a la que se le va a asignar el dictamen
   * @returns cadena de texto con el nombre del estado en que se encuentra la prorroga
   */
  getNombreEstadoProrrogaBack(solicitud) {
    switch (solicitud.prorroga) {
      case 1:
        return solicitud.visto_bueno_prorroga == 1
          ? 'VISTO BUENO EN TRÁMITE'
          : 'TRÁMITE';
      case 2:
        return 'APROBADA';
      case 3:
        return 'RECHAZADA';
      default:
        return 'NO SOLICITADA';
    }
  }

  /**
   * Función que obtiene los nombres de los estados de la prorroga de la solicitud.
   * @param solicitud Solicitud a la que se le va a asignar el dictamen
   * @returns cadena de texto con el nombre del estado en que se encuentra la prorroga
   */
   getNombreEstadoProrroga(solicitud) {
      switch (solicitud.visto_bueno_prorroga) {
        case 0:
          return 'TRÁMITE';
        case 1:
          return 'VISTO BUENO EN TRÁMITE';
        default:
          switch (solicitud.prorroga) {
            case 2:
              return 'APROBADA';
            case 3:
              return 'RECHAZADA';
            default:
              return 'NO SOLICITADA';
          }
      }
  }

  descargarDocumentoResolucion(idDocumento: string): void {
    this.visibleSpinner = true;
    this.solicitudesService.descargarDocumento(idDocumento).subscribe((response) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      this.visibleSpinner = false;
    });
  }

  //SE ELIMINA ARCHIVO AL CERRAR MODAL
  limpiarArchivo(fileUpload: any){
    fileUpload.clear();
    this.file1 = null;
  }
}
